// Utils.js

// Tìm vị trí phần tử có độ dài chuỗi là 4 và chỉ chứa ký tự "Đ" và "S"
export function splitSpecialElements(data) {
  return data.map(row => {
    const newRow = [];
    row.forEach(item => {
      if (item.length === 4 && /^[ĐS]+$/.test(item)) {
        newRow.push(...item.split(''));
      } else {
        newRow.push(item);
      }
    });
    return newRow;
  });
}

// Hàm chuyển dữ liệu dọc thành ngang
export function transposeData(data) {
  const transposedData = [];
  data.forEach((row, rowIndex) => {
    row.forEach((cell, colIndex) => {
      if (!transposedData[colIndex]) {
        transposedData[colIndex] = [];
      }
      transposedData[colIndex][rowIndex] = cell;
    });
  });
  return transposedData;
}
